<template>
  <transition name="share-popup">
    <div class="popup-back">
      <div class="popup pop-common-share">
        <div @click="close()" class="popup-button-close">
          <button>
            <img src="../../assets/images/common/btn-popup-close.png" alt="btn-close">
          </button>
        </div>
        <h1>공유</h1>
        <ul class="sns-share">
          <li>
            <a @click.prevent="clickTwitter()" href="#">
              <div class="sns-img">
                <img src="../../assets/images/common/ico-share-twitter.png" alt="twitter">
              </div>
              <strong>트위터</strong>
            </a>
          </li>
          <li>
            <a @click.prevent="clickFacebook()" href="#">
              <div class="sns-img">
                <img src="../../assets/images/common/ico-share-facebook.png" alt="facebook">
              </div>
              <strong>페이스북</strong>
            </a>
          </li>
        </ul>
        <ul class="share-link">
          <li>
            <input id="page-link" type="text" v-model="url">
          </li>
          <li>
            <button @click.prevent="clickCopyLink()">링크복사</button>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import constant from '@/common/resources/constant'
import { parseUrl, stringify } from 'query-string'

export default {
  props: {
    close: {
      type: Function
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    image: {
      type: String
    }
  },
  data () {
    return {
      url: window.location.protocol + '//' + window.location.host + window.location.pathname + window.location.search
    }
  },
  methods: {
    prependProtocol (url) {
      if (url.indexOf('http:') > -1 || url.indexOf('https:') > -1) {
        return url
      } else {
        return `http://${url}`
      }
    },
    clickFacebook () {
      function buildLink (targetUrl) {
        const { url, query } = parseUrl(targetUrl)
        const params = Object.assign({}, query, { contenttype: url.split('/').pop() })
        return `https://devwavveweb.azurewebsites.net/api/link?${stringify(params)}`
      }
      /* eslint-disable */
      FB.ui({
    		method: 'share',
        href: buildLink(this.url)
    	},
    	function (response) {
        if (response && !response.error_message) {
          // then get post content
        } else {
        }
    	});

      return false;
    },
    clickTwitter() {
      const popup = window.open('https://twitter.com/share?text=' + '[wavve] ' + encodeURIComponent(this.title) + '%0a'
        + encodeURIComponent(this.description) + '%0a&url='
        + encodeURIComponent(this.url), '트위터 공유', 'width=626,height=436');
      popup.window.focus();
    },
    clickCopyLink() {
      const element = document.getElementById('page-link');
      element.select();
      document.execCommand('Copy');
      alert(constant.MSG_SHARE_COMPLETE_COPY_LINK);
    }
  },
  beforeCreate () {
    window.fbAsyncInit = function() {
      FB.init({
        appId            : '1818575348440201',
        autoLogAppEvents : true,
        version          : 'v4.0'
      });
    };

    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/ko_KR/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }
};
</script>

<style>
.share-popup-enter-active, .share-popup-leave-active{
  transition: opacity .3s
}

.share-popup-enter, .share-popup-leave-to{
  opacity: 0
}
</style>
